import React from 'react';

import styled from 'styled-components';

import { useAppSelector } from 'store/hook';

import SidebarSelector from './Selector/SidebarSelector';
import SidebarLogo from './SidebarLogo';
import SidebarMenu from './SidebarMenu';
import SidebarViewAsSupportedUser from './SidebarViewAsSupportedUser';
import { isMysteryShopAdmin, isMysteryShopShopper } from '../../../helpers/permissions';
import { useNavigationContext } from '../Content/NavigationContext';

const Container = styled.div`
  min-width: 210px;
  max-width: 210px;
  display: flex;
  flex-direction: column;
  background: linear-gradient(to top, var(--sidebar-purple-dark) 20%, var(--sidebar-purple-light));

  @media (max-width: 768px) {
    display: none;
  }

  &.mobile {
    display: none;
    @media (max-width: 768px) {
      display: block;
      position: fixed;
      top: 0;
      left: 0;
      z-index: 6;
      width: 300px;
      max-width: 300px;
    }
  }
`;

const StyledCloseButton = styled.div`
  display: none;
  width: 24px;
  height: 24px;
  position: absolute;
  top: 27px;
  left: 12px;
  cursor: pointer;

  @media (max-width: 768px) {
    display: block;
  }
`;

type Props = {
  className?: string;
};

const Sidebar = ({ className }: Props) => {
  const { closeMobileSidebar } = useNavigationContext();
  const currentUser = useAppSelector((state) => state.auth.currentUser);

  const showSelector =
    currentUser &&
    (currentUser?.manager ||
      currentUser?.isSuperuser ||
      (!isMysteryShopAdmin(currentUser) && !isMysteryShopShopper(currentUser)));

  return (
    <Container className={className}>
      <StyledCloseButton onClick={closeMobileSidebar}>
        <img src="/icons/close-gray.svg" width={24} height={24} />
      </StyledCloseButton>
      <SidebarLogo />
      {showSelector && <SidebarSelector />}
      <SidebarViewAsSupportedUser />
      <SidebarMenu />
    </Container>
  );
};

export default Sidebar;
